import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=086e68fc&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=086e68fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e68fc",
  null
  
)

export default component.exports